import { TenantContractResponse } from "@/modules/property-tracks/dtos/tenants";
import { Box, Stack } from "@mui/material";

import Contract from "./tenant-contract";
import useDownloadGeneratedContracts from "@/modules/property-tracks/hooks/tenants/download-files";
import { NwButton } from "@nawy/ui";

function Contracts({
  currentTenant,
}: Readonly<{ currentTenant: TenantContractResponse }>) {
  const { download, isDownloading } = useDownloadGeneratedContracts();

  const handleDownloadAll = () =>
    download({
      contractUids: [
        currentTenant.uid,
        ...(currentTenant?.annexes ?? []).map((contract) => contract.uid),
      ],
    });

  return (
    <Stack
      width="100%"
      borderRadius={(theme) => theme.nawy.radius.xl}
      p={(theme) => theme.nawy.spacing.md}
      pt={0}
      bgcolor="white"
      sx={{ userSelect: "none" }}
      gap={(theme) => theme.nawy.spacing.md}
      position="relative"
    >
      <Stack
        gap={(theme) => theme.nawy.spacing.md}
        maxHeight={{ mobile: 300, tablet: 200, desktop: 470 }}
        overflow="auto"
      >
        <Contract contract={currentTenant} />
        {currentTenant?.annexes.map((contract) => (
          <Contract key={contract.uid} contract={contract} />
        ))}
      </Stack>

      <Box position="sticky" width="100%" bgcolor="white">
        <NwButton
          variant="tonal"
          disabled={isDownloading}
          fullWidth
          onClick={handleDownloadAll}
        >
          Download All
        </NwButton>
      </Box>
    </Stack>
  );
}

export default Contracts;
